import { FC } from 'react';
import {
  TextTitle,
  Spacer,
  LoadingInfo,
  logos,
} from '@pypestream/design-system';

const LOADING_STEP_NAMES = [
  'Preparing your workspace framework…',
  'Setting up the initial system structure…',
  'Getting the canvas ready for building…',
  'Establishing the foundation for your solution…',
  'Aligning core components behind the scenes…',
  'Configuring the environment for your workflows…',
  'Organizing the elements that support your workspace…',
  'Syncing essential system processes…',
  'Creating the base layout for your project…',
  'Initializing key platform services…',
  'Preparing the space where your workflows will live…',
  'Confirming everything is ready for your first steps…',
  'Structuring the environment for smooth orchestration…',
  `Loading the tools you'll need to start creating…`,
  'Setting up integration points for future connections…',
  'Bringing foundational logic online…',
  'Stabilizing the workspace for editing…',
  'Getting your environment ready to grow…',
  'Finalizing the setup for your solution space…',
  'Your workspace will be ready in a moment.',
];

export const StepLoading: FC<{ active: boolean }> = ({ active = false }) => {
  return (
    <div>
      <TextTitle size="small" textAlign="center">
        Creating Your Solution
      </TextTitle>
      <Spacer size="xlarge" />
      <LoadingInfo
        paused={!active}
        steps={LOADING_STEP_NAMES}
        icon={logos.proStudio}
      />
    </div>
  );
};
